import { ValidationRules, ValidationController, ValidationControllerFactory, validateTrigger, Validator } from 'aurelia-validation';
import { RegistrationController } from '../../controllers/registration-controller'
import { newInstance, autoinject, Aurelia } from 'aurelia-framework';
import { Redirect, Router } from 'aurelia-router';
import { DefaultValidationRenderer } from "../../resources/renderers/default-validation-renderer";
import { PageMessageService } from "../../services/page-message-service";
import { BusyService } from "../../services/busy-service";
import { Carrier } from "../../models/carrier";
import { WebApiService } from '../../services/web-api-service';
import { Contact } from '../../models/contact';
import { ContactPhone } from '../../models/contact-phone';

@autoinject()
export class Details {
    constructor(private router: Router, public reg: RegistrationController,
        private controllerFactory: ValidationControllerFactory,
        private pageMessageService: PageMessageService,
        private busyService: BusyService,
        private api: WebApiService,
        private aurelia: Aurelia
    ) {

        this.controller = controllerFactory.createForCurrentScope();
        this.controller.validateTrigger = validateTrigger.blur;
        this.controller.addRenderer(new DefaultValidationRenderer());
    }

    attached() {
        (<any>$(".info-button")).popover();
    }

    public addContact() {
        var emptyContact = new Contact();
        emptyContact.phones = [new ContactPhone()];
        this.reg.carrier.contacts.push(emptyContact);
        this.contactTypesChanged();
    }

    public removeContact(contact) {
        this.reg.carrier.contacts.splice(this.reg.carrier.contacts.indexOf(contact), 1);
        this.contactTypesChanged();
    }

    public contactIsOwner = false;
    public contactIsAdministrator = false;
    public contactIsAccountingRep = false;
    public contactIsRateContact = false;
    public contactIsDispatch = false;
    public contactIsNewBusinessContact = false;
    public contactIsInsuranceContact = false;
    public contactIsEftContact = false;
    public contactIs24HrContact = false;

    public contactTypesChanged() {
        this.contactIsOwner = false;
        this.contactIsAdministrator = false;
        this.contactIsAccountingRep = false;
        this.contactIsRateContact = false;
        this.contactIsDispatch = false;
        this.contactIsNewBusinessContact = false;
        this.contactIsInsuranceContact = false;
        this.contactIsEftContact = false;
        this.contactIs24HrContact = false;

        this.reg.carrier.contacts.forEach(o => {
            if (o.contactTypeIds.indexOf(2) > -1)
                this.contactIsOwner = true;
            if (o.contactTypeIds.indexOf(1) > -1)
                this.contactIsAdministrator = true;
            if (o.contactTypeIds.indexOf(7) > -1)
                this.contactIsAccountingRep = true;
            if (o.contactTypeIds.indexOf(12) > -1)
                this.contactIsRateContact = true;
            if (o.contactTypeIds.indexOf(3) > -1)
                this.contactIsDispatch = true;
            if (o.contactTypeIds.indexOf(42) > -1)
                this.contactIsNewBusinessContact = true;
            if (o.contactTypeIds.indexOf(45) > -1)
                this.contactIsEftContact = true;
            if (o.contactTypeIds.indexOf(46) > -1)
                this.contactIs24HrContact = true;
            if (o.contactTypeIds.indexOf(11) > -1)
                this.contactIsInsuranceContact = true;
        });
    }

    contactTypes: Array<any> = [];

    controller: ValidationController = null;

    canActivate(params): any {

        // ////enable this page as entry point for debugging (only for local environment)
        // if ((<any>this.aurelia.host.attributes).environment.value.toLowerCase() == "local") {
        //     if (!this.reg.carrier) {
        //         this.reg.carrier = new Carrier();
        //         this.reg.carrier.legalName = "DYNAMITE DOCUMENT DESTRUCTION";
        //         this.reg.carrier.dotNumber = "1232032";
        //     }
        //  }

         if (!this.reg.carrier) {
            return new Redirect("registration/begin?id=" + params.id);
        } else {
            return !this.reg.carrier.isSubmitted;
        }
    }

    async activate() {

        if (!this.reg.carrier) {

        }

        await this.loadContactTypes();
        //this.reg.carrier = new Carrier();
        //this.reg.carrier.legalName = "DYNAMITE DOCUMENT DESTRUCTION";
        //this.reg.carrier.dotNumber = "1232032";
    }

    async loadContactTypes() {
        const result = await this.api.get("Registration", "GetContactTypes")
        const contactTypes = JSON.parse(result.response);
        this.contactTypes = contactTypes.filter(o => {
            if (o.carrier == true) {
                if (this.reg.carrier.isTrucksCarrier) {
                    return true;
                } else {
                    // for non-trucks, do not require rate or dispatch contact 
                    if (o.id == 3	/* Dispatcher */
                        || o.id == 12	/* Rate */) {
                        return false;
                    } else {
                        return true;
                    }
                }
            }
        });
    }

    public allContactTypesSelected = false;

    submit() {

        this.pageMessageService.clear();
        this.controller
            .validate()
            .then(v => {
                if (v.length === 0) {
                    this.router.navigate("/registration/carrier-info?id=" + this.reg.requestId);
                }
                else {
                    this.pageMessageService.setErrorMessage("Fix errors below");
                }
            });
    }
}
